
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc4c26cc84e93db5a006c990ae4d8aef8en from './en.yaml'
            i18n.addResourceBundle('en', 'c4c26cc84e93db5a006c990ae4d8aef8', flattenObject(nsc4c26cc84e93db5a006c990ae4d8aef8en), true, true);
        
        export default 'c4c26cc84e93db5a006c990ae4d8aef8';
    